import { render } from "./Modal.vue?vue&type=template&id=15a4627e"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=15a4627e&lang=scss"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__